import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import * as Yup from "yup";
import { APIURL } from "../../../Config";

function CreateCorporateWorkspace() {
  const LoginSchema = Yup.object().shape({
    mobile: Yup.string()
      .required("required")
      .min(10, "MobileNo must be 10 characters at minimum"),
    empname: Yup.string().required("required"),
    corporateName: Yup.string().required("required"),
    noofemployees: Yup.string().required("required"),
    designation: Yup.string().required("required"),
  });
  return (
    <div className="pt-3">
      <div className="card">
        <div className="p-4">
          <Formik
            initialValues={{
              empname: "",
              designation: "",
              corporateName: "",
              mobile: "",
              numEmp: "",
              amount: "",
              cCode: "",
            }}
            validationSchema={LoginSchema}
            onSubmit={(values) => {
              console.log("values", values);
              // let dto = {
              //   ...values,
              //   emailId: email,
              //   corporateId: corporateId,
              // };
              // console.log("dto", dto);
              // const token = localStorage.getItem("token");
              // setIsLoader(true);
              // axios
              //   .request(`${APIURL}/customer/workspacecreate`, {
              //     method: "POST",
              //     data: dto,
              //     headers: {
              //       Authentication: token,
              //       "Content-Type": "application/json",
              //      ,
              //     },
              //   })
              //   .then((response) => {
              //     console.log("response:::", response);
              //     setIsLoader(false);
              //     toast.success("Create your workspace successfully...");
              //   })
              //   .catch((error) => {
              //     console.log("error", error);
              //     setIsLoader(false);
              //     toast.warning("User does not exist...");
              //   });
            }}
          >
            {({ touched, errors }) => (
              <>
                <Form>
                  <div>
                    <div>
                      <h4
                        className="py-2 text-center"
                        style={{ color: "#66a725", fontWeight: 800 }}
                      >
                        Create a new Corporate Workspace
                      </h4>
                      <div>
                        <label>Company Name*</label>
                        <Field
                          type="text"
                          name="corporateName"
                          placeholder="Enter Company Name"
                          className={`form-control
                          ${
                            touched.corporateName && errors.corporateName
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="corporateName"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="mt-2">
                        <label>Your Name*</label>
                        <Field
                          type="text"
                          name="empname"
                          placeholder="Enter Name"
                          className={`form-control
                          ${
                            touched.empname && errors.empname
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="empname"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="mt-2">
                        <label>Mobile No*</label>
                        <Field
                          type="number"
                          name="mobile"
                          placeholder="Enter Mobile No"
                          className={`form-control
                          ${
                            touched.mobile && errors.mobile ? "is-invalid" : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="mobile"
                          className="invalid-feedback"
                        />
                      </div>
                    </div>
                    <div className="mt-2">
                      <label>Company Code*</label>
                      <Field
                        type="text"
                        name="cCode"
                        placeholder="Enter Company Code"
                        className={`form-control
                          ${touched.cCode && errors.cCode ? "is-invalid" : ""}`}
                      />
                      <ErrorMessage
                        component="div"
                        name="cCode"
                        className="invalid-feedback"
                      />
                    </div>

                    <div className="">
                      <div className="mt-2">
                        <label>Designation*</label>
                        <Field
                          type="text"
                          name="designation"
                          placeholder="Enter Designation"
                          className={`form-control
                          ${
                            touched.designation && errors.designation
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <ErrorMessage
                          component="div"
                          name="designation"
                          className="invalid-feedback"
                        />
                      </div>

                      <div className="mt-2">
                        <label>Expected number of employees*</label>
                        <Field
                          as="select"
                          name="numEmp"
                          placeholder="Enter number of employees"
                          className={`form-control
                          ${
                            touched.numEmp && errors.numEmp ? "is-invalid" : ""
                          }`}
                        >
                          <option value="">Select..</option>
                          <option value="1-10">1-10</option>
                          <option value="11-25">11-25</option>
                          <option value="26-100">26-100</option>
                          <option value="101-300">101-300</option>
                          <option value="301-1000">301-1000</option>
                          <option value="1001-3000">1001-3000</option>
                          <option value="3001-10,000">3001-10,000</option>
                          <option value="10,000 +">10,000 +</option>
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="numEmp"
                          className="invalid-feedback"
                        />
                      </div>
                      <div className="mt-2">
                        <label>Expected total limit amount *</label>
                        <Field
                          as="select"
                          name="amount"
                          placeholder="Enter total limit amount"
                          className={`form-control
                          ${
                            touched.amount && errors.amount ? "is-invalid" : ""
                          }`}
                        >
                          <option value="">Select..</option>
                          <option value="Under 10,000">Under 10,000</option>
                          <option value="10,000-1L">10,000-1L</option>
                          <option value="1-3L">1-3L</option>
                          <option value="3-10L">3-10L</option>
                          <option value="10L-20L">10L-20L</option>
                          <option value="20-50L">20-50L</option>
                          <option value="50-1Cr">50-1Cr</option>
                          <option value="1Cr-3Cr">1Cr-3Cr</option>
                          <option value="3-10Cr">3-10Cr</option>
                          <option value="10Cr +">10Cr +</option>
                        </Field>
                        <ErrorMessage
                          component="div"
                          name="amount"
                          className="invalid-feedback"
                        />
                      </div>

                      <button
                        className="btn btn-success mt-3 border"
                        type="submit"
                        style={{ backgroundColor: "#66a725" }}
                      >
                        {/* {isLoader ? (
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          "Submit"
                        )} */}
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default CreateCorporateWorkspace;
